import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

// GET /admin/catalog/products/:productId/recent-quotes — the admin-mounted
// mirror of hooks/useRecentQuotes.js's sales-facing read (same underlying
// service call, quotationService.listRecentQuotesForProduct — no cost
// fields exist in this read to begin with). Kept as its OWN hook/route
// rather than reusing the sales one with a role branch inside it —
// admin/CLAUDE.md: "Build sales and admin views as separate components
// rather than one component with conditionals — it makes an accidental
// leak visible in review."
export function useAdminRecentQuotes(productId, excludeQuotationId) {
  return useQuery({
    queryKey: ['admin', 'recent-quotes', productId ?? null, excludeQuotationId ?? null],
    queryFn: () =>
      apiClient.get(`/admin/catalog/products/${productId}/recent-quotes`, { excludeQuotationId }),
    select: (data) => data.quotes,
    enabled: Boolean(productId),
  });
}

export default useAdminRecentQuotes;
